import { Page } from '$core/models/page';
import { LanguageService } from '$core/services/language.service';
import { Component, computed, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  faChevronDown,
  faSearch,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { BlogSearchService } from '../../services/search.service';
import { StaticService } from '../../services/static.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  protected readonly languageService = inject(LanguageService);
  private readonly blogSearchService = inject(BlogSearchService);
  private readonly route = inject(ActivatedRoute);
  private readonly staticService = inject(StaticService);

  public readonly faChevronDown = faChevronDown;
  public readonly faSearch = faSearch;
  public readonly faTimes = faTimes;
  public readonly Page: Page;

  protected readonly menu = computed(() => this.staticService.static().header);

  protected readonly mainSiteUrl = computed(
    () => this.staticService.static().main_site || ''
  );

  protected readonly isInnerUser = computed(
    () => this.staticService.static().user_type === 'inner'
  );

  public routerLinkActiveClass = 'current';
  public isDropdownToggledManually = false;
  public isHoverOnDropdow = false;
  public isSearchOpen = false;

  public get searchQuery(): string {
    if (!this.route.snapshot.queryParams['search']) {
      return '';
    }
    return this.route.snapshot.queryParams['search'];
  }

  public get lang() {
    return this.languageService.currentLang;
  }

  public ngOnInit() {
    if (this.searchQuery) {
      this.isSearchOpen = true;
    }
  }

  public onMouseLeave(dropdown: BsDropdownDirective) {
    setTimeout(() => {
      if (this.isHoverOnDropdow) {
        return;
      }

      dropdown.hide();
    }, 0);
  }

  public closeDropdown(dropdown: BsDropdownDirective) {
    dropdown['timeout'] = setTimeout(() => dropdown.hide(), 100);
  }

  public preventClosingDropdown(dropdown: BsDropdownDirective) {
    clearInterval(dropdown['timeout']);
  }

  public onLangSelected(e: Event) {
    const target = e.target as HTMLSelectElement;
    this.languageService.change(target.value);
  }

  public async onSearch(search: string) {
    this.blogSearchService.triggerSearch(search);
  }
}
